import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { usercommonattribute } from '../../_services/userservice/user.common.service';

@Injectable()
export class UserStateService {
  private subcUserdetail = new ReplaySubject<any>(1);
  private subLoyaltyUserdetail = new ReplaySubject<any>(1);
  constructor() {}

  setcurrentUserDetailData(dataValues: any) {
    this.subcUserdetail.next(dataValues);
  }

  getcurrentUserDetailData(): Observable<any> {
    return this.subcUserdetail.asObservable();
  }

  setLoyaltyUserDetailData(dataValues: any) {
    this.subLoyaltyUserdetail.next(dataValues);
  }

  getLoyaltyUserDetailData(): Observable<any> {
    return this.subLoyaltyUserdetail.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/userstateservice.ts